/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import { sanitizer } from "../../common/helpers/helpers";

function DangerousHtml({ str, isDirty, className }) {
  const clean = isDirty ? sanitizer.sanitizeAllowHtml(str) : str;

  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />
  );
}

DangerousHtml.propTypes = {
  str: PropTypes.string,
  isDirty: PropTypes.bool,
  className: PropTypes.string,
};

DangerousHtml.defaultProps = {
  str: "",
  isDirty: true,
  className: "",
};

export default React.memo(DangerousHtml);
